import authHttp, { onUnauthorized } from "./authHttp";

const URL_SIGNUP = "/auth/signup";
const URL_LOGIN = "/auth/login";
const URL_LOGOUT = "/auth/logout";
const URL_SESSION = "/auth/session";

// Dedupes the root loader + leaf route loader that react-router fires on
// the same navigation tick, so a single navigation issues one /auth/session
// request instead of two. Short TTL so a real session change (login/logout
// elsewhere, server-side revocation) is still picked up promptly.
const SESSION_CACHE_TTL_MS = 15000;
let cachedSessionPromise = null;
let cachedSessionAt = 0;

export function invalidateSession() {
  cachedSessionPromise = null;
  cachedSessionAt = 0;
}

onUnauthorized(invalidateSession);

export function getSession() {
  const now = Date.now();
  if (cachedSessionPromise && now - cachedSessionAt < SESSION_CACHE_TTL_MS) {
    return cachedSessionPromise;
  }
  // Set the cache synchronously (before the request resolves) so a second
  // loader firing on the same tick reuses this in-flight promise.
  cachedSessionAt = now;
  cachedSessionPromise = authHttp
    .get(URL_SESSION)
    .then((response) => response.data?.user ?? null)
    .catch((error) => {
      cachedSessionPromise = null;
      if (error.response && error.response.status === 401) {
        return null;
      }
      console.error("Session check failed", error);
      return null;
    });
  return cachedSessionPromise;
}

async function submitAuth(url, authData) {
  try {
    const response = await authHttp.post(url, authData);
    invalidateSession();
    return { ok: true, data: response.data };
  } catch (error) {
    const response = error.response;
    if (response && [401, 422, 429].includes(response.status)) {
      return { ok: false, status: response.status, data: response.data || {} };
    }
    throw error;
  }
}

export const loginUser = (authData) => submitAuth(URL_LOGIN, authData);
export const signupUser = (authData) => submitAuth(URL_SIGNUP, authData);

export async function logoutUser() {
  try {
    await authHttp.post(URL_LOGOUT);
  } catch (error) {
    console.error("Logout request failed", error);
  } finally {
    invalidateSession();
  }
}
